import React from 'react';

import {
  type ToggleProps,
  Toggle,
} from '@fragment/ui/src/components/Toggle/Toggle';

type BillingToggleProps<
  WidthProp,
  HeightProp,
  PaddingProp,
  FlexContainerProp,
  BorderColorProp
> = Omit<
  ToggleProps<
    WidthProp,
    HeightProp,
    PaddingProp,
    FlexContainerProp,
    BorderColorProp
  >,
  'variant'
>;

/**
 * Toggle with billing dashboard styling (gap between buttons, canvas/transparent backgrounds).
 * Use this on payments/billing pages instead of the shared Toggle.
 */
export const BillingToggle = <
  WidthProp,
  HeightProp,
  PaddingProp,
  FlexContainerProp,
  BorderColorProp
>(
  props: BillingToggleProps<
    WidthProp,
    HeightProp,
    PaddingProp,
    FlexContainerProp,
    BorderColorProp
  >
): JSX.Element => (
  <Toggle
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...(props as ToggleProps<
      WidthProp,
      HeightProp,
      PaddingProp,
      FlexContainerProp,
      BorderColorProp
    > & { variant?: 'billing' })}
    variant="billing"
  />
);
